<template>
  <smd-one-col-layout content-styles="full-width">
    <div class="cancelled-rejected">
      <div class="cancelled-rejected__text-container">
        <p v-html="getContent.header"
           class="Title1"></p>
        <p v-html="getContent.description"
           class="Body1"></p>

        <template v-if="bookingDetails.status === $options.ONDEMAND_STATUSES.REJECT">
          <p class="Body1"><span class="Body2">Reason: </span>{{ rejectReason }}</p>
        </template>
      </div>

      <div class="cancelled-rejected__divider"></div>

      <div v-if="loading" class="loading-spinner">
        <smd-loading-spinner/>
      </div>

      <div v-if="similarDoctors.length" class="cancelled-rejected__options">
        <p class="Body2">Here are similar doctors that you might be interested in:</p>
        <div class="doctor-list">
          <card-doctor-details v-for="doctor in similarDoctors"
                               :key="doctor.doctorid"
                               :doctor="doctor"
                               :campaign-id="bookingDetails.campaignid"/>
        </div>
      </div>
      
      <smd-btn :disabled="loading"
                section="4"
                variant="blue-enabled"
                type="submit"
                @click="seeMoreDoctors">
        See similar doctors
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {
    ONDEMAND_STATUSES,
  } from '@/reference/ondemand';
  import {OnDemandService} from '@/services/ondemand';
  import {
    GETTER_ONDEMAND_BOOKING_DETAILS,
  } from '@/store/types';
  import CardDoctorDetails from '@/components/card-doctor-details.vue';

  export default {
    name: 'cancelled-rejected',
    components: {
      CardDoctorDetails,
    },
    data() {
      return {
        loading: false,
        similarDoctors: [],
      };
    },
    computed: {
      ...mapGetters({
        bookingDetails: GETTER_ONDEMAND_BOOKING_DETAILS,
      }),
      getContent() {
        const MAP_CONTENT = {
          [ONDEMAND_STATUSES.REJECT]: this.$options.REJECT_CONTENT,
          [ONDEMAND_STATUSES.CANCELLED]: this.$options.CANCELLED_CONTENT,
          [ONDEMAND_STATUSES.AUTOCANCELLED]: this.$options.AUTOCANCELLED_CONTENT,
          [ONDEMAND_STATUSES.PAYMENT_AUTOCANCELLED]: this.$options.PAYMENT_AUTOCANCELLED_CONTENT,
        }

        if (MAP_CONTENT[this.bookingDetails.status]) {
          return MAP_CONTENT[this.bookingDetails.status];
        }

        return '';
      },
      rejectReason() {
        return this.bookingDetails.rejectreason;
      },
    },
    mounted() {
      this.getDoctors();
    },
    methods: {
      async getDoctors() {
        this.loading = true;

        try {
          const queryParams = {
            limit: 3,
            seed: (new Date()).valueOf(),
            OnDemandCampaignId: this.bookingDetails.campaignid,
          };
          const {data} = await OnDemandService.getDoctors(queryParams);

          this.loading = false;

          if (data && data.length) {
            this.similarDoctors = data;
          }
        } catch (error) {
          console.error(error);
          this.loading = false;
        }
      },
      seeMoreDoctors() {
        let url = process.env.VUE_APP_DOCTOR_PROFILE_AND_BOOKING_URL;
        const doctorSearchMap = {
          ondemandvideoconsult: 'primary-care-and-general-medicine',
          ondemandvideoconsult_pedia: 'pediatrics',
          ondemandvideoconsult_ob: 'ob-gyn-and-womens-health',
          ondemandvideoconsult_mental: 'mental-health',
          ondemandvideoconsult_derma: 'skin-and-dermatology',
        };

        if (doctorSearchMap[this.bookingDetails.campaignid]) {
          url += `/specialty/${doctorSearchMap[this.bookingDetails.campaignid]}`;
        }

        window.open(url, '_self');
      },
    },
    ONDEMAND_STATUSES,
    PAYMENT_AUTOCANCELLED_CONTENT: {
      header: `Booking <span class="crimson">Cancelled</span>`,
      description: `Due to the expiration of the allotted payment completion time, your booking has been automatically cancelled.<br>If you still require an immediate consultation with a doctor, please proceed to book again.`,
    },
    CANCELLED_CONTENT: {
      header: `Consultation Request Update`,
      description: `We see that you've cancelled your request. We understand that circumstances can change. Whenever you're ready, we're here to help you connect with other available doctors.<br><br>We value your trust and are here to assist you with future bookings. Thank you for choosing our service.`,
    },
    AUTOCANCELLED_CONTENT: {
      header: `Consultation Update`,
      description: `Your doctor was unable to respond to your inquiry within the expected time frame.<br><br>We value your health and are investigating the situation. Rest assured, your payment has been automatically refunded.<br><br>We recommend rescheduling or seeking another available physician. We appreciate your patience and understanding`,
    },
    REJECT_CONTENT: {
      header: `Request Declined`,
      description: `Your doctor was unable to accept your request at this time. We value your health and are investigating the situation. Rest assured, your payment has been automatically refunded. We appreciate your patience and understanding.`,
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .cancelled-rejected {
    @extend %layout--flex-col;
    gap: 16px;

    &__text-container {
      @extend %layout--flex-col;
      gap: 8px;
    }

    &__divider {
      border: 1px solid color(gray-100);
      width: 100px;
    }

    &__options {
      @extend %layout--flex-col;
      gap: 12px;

      .doctor-list {
        @extend %layout--flex-col;
        gap: 16px;
        align-items: center;
      }
    }

    > button {
      margin: 0 auto;
      width: 100%;
      max-width: 256px;
    }
  }
</style>
